import { useGetSimCustomerActions } from "@/services/api";
import { isInBillDunning } from "@/utils/customerUtils";

export const useHasBillDunning = (): boolean => {
  const { data: simCustomerActions } = useGetSimCustomerActions();

  return isInBillDunning(simCustomerActions);
};
